import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ridango-date-period-selector',
    templateUrl: './date-period-selector.component.html',
    styleUrls: ['./date-period-selector.component.scss']
})
export class DatePeriodSelectorComponent implements OnInit {
    @Input() startDate;
    @Input() endDate;

    @Input() maxStartDate;
    @Input() minStartDate;

    @Input() maxEndDate;
    @Input() minEndDate;

    @Input() automaticEnd = true;
    @Input() diff;

    @Input() startLabel = null;
    @Input() endLabel = null;

    @Output() startDateSet = new EventEmitter<Date>();
    @Output() endDateSet = new EventEmitter<Date>();
    @Output() commitPeriodSelect = new EventEmitter<any>();
    @Output() print = new EventEmitter<void>();

    @Input() dateFormat = 'yyyy-MM-dd';

    @Input() showText = true;
    @Input() showPrint = true;
    @Input() showTitle = true;
    @Input() useMaterialIcon;
    @Input() allowFuture = false;

    @Input() locale = 'en';

    startAriaLabel = 'DATE_PICKER_START_DATE_INPUT_ARIA_LABEL';
    endAriaLabel = 'DATE_PICKER_END_DATE_INPUT_ARIA_LABEL';

    ngOnInit(): void {
        this.setEndDate();
    }

    setEndDate() {
        if (!this.automaticEnd) {
            this.minEndDate = this.startDate;
        }
    }

    startDateUpdated(date: Date) {
        this.startDate = date;
        this.startDateSet.emit(this.startDate);
        if (this.automaticEnd) {
            let modified = new Date(date);
            modified = new Date(modified.setDate(modified.getDate() + this.diff));
            if (!this.allowFuture && modified.getTime() > this.maxEndDate.getTime()) {
                this.endDate = this.maxEndDate;
            } else {
                this.endDate = modified;
            }
            this.endDateSet.emit(this.endDate);
            // calc ending. NB! bear in mind maxEnd date and today etc. If calc is bigger than maxEnd then maxEnd should be selected
        } else {
            this.setEndDate();
        }
    }

    endDateUpdated(date: Date) {
        this.endDateSet.emit(date);
    }

    commitPeriod() {
        this.commitPeriodSelect.emit();
    }

    triggerPrint() {
        this.print.emit();
    }
}
